import { useState } from 'react';
import {
	Box,
	Button,
	TextField,
	Typography,
	Paper,
	InputAdornment,
	IconButton,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { changePassword } from '../../services/userService';
import ModalComponent from '../../components/modal/modal.component';

export const ChangePassword = () => {
	const navigate = useNavigate();
	const [formData, setFormData] = useState({
		currentPassword: '',
		newPassword: '',
		confirmPassword: ''
	});
	const [error, setError] = useState('');

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setFormData({
			...formData,
			[e.target.name]: e.target.value
		});
	};

	const [modalOpen, setModalOpen] = useState(false);

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setError('');

		if (formData.newPassword !== formData.confirmPassword) {
			setError('Las contraseñas nuevas no coinciden');
			return;
		}

		try {
			await changePassword(formData.currentPassword, formData.newPassword);
			setModalOpen(true);
		} catch (err: any) {
			setError(err.message);
		}
	};

	const [showPassword, setShowPassword] = useState(false);

	const handleTogglePasswordVisibility = () => {
		setShowPassword((prev) => !prev);
	};

	return (
		<Box sx={{ maxWidth: 400, mx: 'auto', mt: 4 }}>
			<Paper sx={{ p: 3 }}>
				<Typography variant="h5" gutterBottom>
					Cambiar Contraseña
				</Typography>
				<form onSubmit={handleSubmit}>
					<TextField
						fullWidth
						margin="normal"
						label="Contraseña actual"
						type={showPassword ? 'text' : 'password'}
						name="currentPassword"
						value={formData.currentPassword}
						onChange={handleChange}
						required
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									<IconButton
										onClick={handleTogglePasswordVisibility}
										edge="end"
									>
										{showPassword ? <Visibility /> : <VisibilityOff />}
									</IconButton>
								</InputAdornment>
							),
						}}
					/>
					<TextField
						fullWidth
						margin="normal"
						label="Nueva contraseña"
						type={showPassword ? 'text' : 'password'}
						name="newPassword"
						value={formData.newPassword}
						onChange={handleChange}
						required
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									<IconButton
										onClick={handleTogglePasswordVisibility}
										edge="end"
									>
										{showPassword ? <Visibility /> : <VisibilityOff />}
									</IconButton>
								</InputAdornment>
							),
						}}
					/>
					<TextField
						fullWidth
						margin="normal"
						label="Confirmar nueva contraseña"
						type={showPassword ? 'text' : 'password'}
						name="confirmPassword"
						value={formData.confirmPassword}
						onChange={handleChange}
						required
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									<IconButton
										onClick={handleTogglePasswordVisibility}
										edge="end"
									>
										{showPassword ? <Visibility /> : <VisibilityOff />}
									</IconButton>
								</InputAdornment>
							),
						}}
					/>
					{error && (
						<Typography color="error" sx={{ mt: 2 }}>
							{error}
						</Typography>
					)}
					<Button
						type="submit"
						variant="contained"
						fullWidth
						sx={{ mt: 3 }}
					>
						Cambiar Contraseña
					</Button>
					<ModalComponent
						open={modalOpen}
						title={'¡Contraseña actualizada!'}
						description={'Tu contraseña fue actualizada exitosamente.'}
						imageSrc="/cambiapp_logo.png"
						buttonText="Volver al inicio"
						onButtonClick={() => navigate('/')}
						onClose={() => navigate('/')}
					/>
				</form>
			</Paper>
		</Box>
	);
}; 